export const GET_SPECIFIC_BOOKMARK = "GET_SPECIFIC_BOOKMARK";
export const IS_LOADING = "IS_LOADING";
export const LIKE_UP = "LIKE_UP";
